var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntrepreneur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.001,
    height: 59.999,
    viewBox: "0 0 60.001 59.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2450ff;}.b{fill:#6dcef8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-840 -1510.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 46,
    rx: 6,
    transform: "translate(840 1524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7601-1569h-4v-6a6.007,6.007,0,0,1,6-6h16a6.007,6.007,0,0,1,6,6v6h-4v-6a2,2,0,0,0-2-2h-16a2,2,0,0,0-2,2v6Z",
    transform: "translate(8461 3091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7586-1573.5a6.009,6.009,0,0,1-5.979-5.5H-7614v-2h60v2h-22.022a6.008,6.008,0,0,1-5.979,5.5Zm0-2h4a4.006,4.006,0,0,0,3.97-3.5h-11.938A4.006,4.006,0,0,0-7586-1575.5Z",
    transform: "translate(8454 3119)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrepreneur);
export default __webpack_public_path__ + "static/media/entrepreneur.947553de2fc7217fc4ac956fa2991a3c.svg";
export { ForwardRef as ReactComponent };